import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('CaseOpeningConfirmation').create(({ theme }) => ({
  root: {
    width: '95%',
    height: '148px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    backgroundColor: '#383839',
    borderRadius: '12px',
  },

  buttonWrapper: {
    width: '100%',
    height: theme.sizes.button.height,
    display: 'flex',
    gap: '8px',
  },

  modalText: {
    fontFamily: 'Inter',
    fontWeight: 550,
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
  },

  backButton: {
    minWidth: '90px',
    height: '100%',
    padding: '24px 14px',
  },

  useButton: {
    width: '100%',
    height: '100%',
    display: 'flex',
    padding: '24px 14px',
    gap: '4px',
  },

  key: {
    width: '18px',
    height: '18px',
  },
}))
